import { IconButton, LinearProgress, Modal, Snackbar, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from '../../form/Form';
import '../Share4rewards/Share4rewards.css'
import RewardFooter from './RewardFooter';
import { checkUniqueCodeAvailability, fetchUniqueData } from './RewardReducer';
import RewardSecFive from './RewardSecFive';
import RewardSecFour from './RewardSecFour';
import RewardSecTwo from './RewardSecFour';
import RewardSecOne from './RewardSecOne';
import RewardSecSix from './RewardSecSix';
import RewardSecThree from './RewardSecThree';
import CallIcon from '@mui/icons-material/Call';
import { Box } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from 'react-hook-form';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { setsubmitBtnDisabled } from '../../form/formReducer';

function Share4rewards() {

    const { uniqueID } = useParams();
    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [locationArry, setLocationArry] = useState([]);
    const [practicelocationArry, setPracticeLocationArry] = useState([]);
    const [loading, setloading] = useState(false);
    const [bannerLoading, setBannerLoading] = useState(false);
    const [snakbaropen, setSnakbaropen] = useState(false);
    const [snackBarMsg, setSnackBarMsg] = useState("");
    const [isNoParam, setIsNoParam] = useState(false);
    const [uniqueCode, setUniqueCode] = useState("");
    const [checkingUniqueCode, setCheckingUniqueCode] = useState(false);
    const [errorInUniqueCode, setErrorInUniqueCode] = useState(false);
    const [uniquePracticeDetails, setUniquePracticeDetails] = useState(null);
    const [showTopBtn, setShowTopBtn] = useState(false);


    const [domainURLLink, setdomainURLLink] = useState("");
    const domainURL = process.env.REACT_APP_PROJECT_ENV;

    const uniqueDetails = useSelector((state) => state.rewardReducer && state.rewardReducer.uniqueDetails ? state.rewardReducer.uniqueDetails : null);
    const uniqueDetailsMessage = useSelector((state) => state.rewardReducer && state.rewardReducer.uniqueDetailsMsg ? state.rewardReducer.uniqueDetailsMsg : null);
    const RewardsFormSubmissionState = useSelector((state) => state.formSlice.formSubmissionState && state.formSlice.formSubmissionState.Share4RewardsForm ? state.formSlice.formSubmissionState.Share4RewardsForm : null);
    const RewardsFormObj = useSelector((state) => state.formSlice.formData && state.formSlice.formData.Share4RewardsForm ? state.formSlice.formData.Share4RewardsForm : null);
    const uniqueCodeAvailability = useSelector((state) => state.rewardReducer && state.rewardReducer.uniqueCodeAvailability ? state.rewardReducer.uniqueCodeAvailability : null);
    const apiLoading = useSelector((state) => state.rewardReducer && state.rewardReducer.loading ? state.rewardReducer.loading : false);

    const onFetchState = async (value) => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify({ search_str: value ? value : "" }),
        };
        const response = await fetch(
            process.env.REACT_APP_API_URL + "api9/fetch-allstates",
            requestOptions
        );

        console.log("response state here >>>>>", response);
        const resResult = await response.json();
        const data = resResult.sates.map((data) => {
            return { val: data.name, name: data.name };
        });
        setLocationArry(data);
    };
    useEffect(() => {
        onFetchState();
        window.addEventListener("scroll", () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);

    useEffect(() => {
        if (domainURL === "dev") {
            setdomainURLLink("https://www.dev.healthriskexam.com/")
        } else {
            setdomainURLLink("https://www.healthriskexam.com/")
        }
        if (!uniqueID) {
            return (
                dispatch(setsubmitBtnDisabled({ flag: false }))
            )
        }
    }, []);

    useEffect(() => {
        if (uniqueID) {
            console.log("uniqueID ", uniqueID);
            let data = {
                "condition": {
                    "practice_unique_name": uniqueID,
                    "user_type": "practice"
                }
            }
            setBannerLoading(true);
            dispatch(fetchUniqueData(data));
            setIsNoParam(true);
        } else {
            dispatch(setsubmitBtnDisabled({ flag: true }))
        }
    }, [uniqueID]);

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 600,
        bgcolor: "background.paper",
        // border: "2px solid #000",
        boxShadow: 24,
        // p: 4,
    };

    useEffect(() => {
        if (RewardsFormSubmissionState === 4) {
            // console.log("RewardsFormObj", RewardsFormObj);
            addapicall(RewardsFormObj)
        }
    }, [RewardsFormSubmissionState]);

    useEffect(() => {
        // console.log("uniqueDetails", uniqueDetails, uniqueDetailsMessage)
        if (uniqueDetails && !apiLoading) {
            setBannerLoading(false);
            if (uniqueDetails.length === 0) {
                setSnakbaropen(true);
                setSnackBarMsg(uniqueDetailsMessage);
                setIsNoParam(true);
            }
            let practiceData = {
                practice_name: uniqueDetails.practice_name,
                phone: uniqueDetails.phone,
                address: uniqueDetails.location_details && uniqueDetails.location_details.length > 0 && uniqueDetails.location_details[0].address + ", " + uniqueDetails.location_details[0].state + ", " + uniqueDetails.location_details[0].city + ", " + uniqueDetails.location_details[0].zip,
                for_reward_partner_contact_no: uniqueDetails.for_reward_partner_contact_no
            }
            setUniquePracticeDetails(practiceData);
        }
    }, [uniqueDetails, apiLoading])

    useEffect(() => {
        if (checkingUniqueCode && !apiLoading) {
            if (uniqueCodeAvailability) {
                navigate(`/${uniqueCode}`)
                setIsNoParam(true);
                setloading(false);
            } else {
                setErrorInUniqueCode(true);
                setloading(false);
            }
        }
    }, [checkingUniqueCode, apiLoading, uniqueCodeAvailability]);

    useEffect(() => {
        let practicelocationArry = [];
        if (uniqueDetails && !apiLoading) {
            for (const key in uniqueDetails.location_details) {
                practicelocationArry.push({ val: uniqueDetails.location_details[key].location_name, name: uniqueDetails.location_details[key].location_name })
            }
        }
        console.warn("uniqueDetails >>>>>>>>>>>>", practicelocationArry);

        setPracticeLocationArry(practicelocationArry);
    }, [uniqueDetails, apiLoading])

    const addapicall = async (dataccc) => {
        let data = JSON.parse(JSON.stringify(dataccc));

        data.practice_id = uniqueDetails._id;
        data.status = 0;
        delete data.formId;
        console.log("RewardsFormObj data", data);
        setloading(true);

        if (data != null) {
            // data.website_information']=websiteInformation
            const requestOptions = {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify(data),
            };
            const response = await fetch(
                process.env.REACT_APP_API_URL + "api3/add-update-partner",
                requestOptions
            );
            // console.log("++++response+++++++",response);

            const respdata = await response.json();
            console.log("RewardsFormObj respdata", respdata);
            if (respdata && respdata.status === "success") {
                if (respdata.results) {
                    setSnakbaropen(true);
                    setSnackBarMsg("Added Successfully");
                    setloading(false);
                    setTimeout(() => {
                        navigate(`/rewards-contract/${respdata.results._id}`)
                    }, 2000)
                }
            } else {
                setloading(false);
                setSnakbaropen(true);
                setSnackBarMsg(respdata.message);
            }
        }
    }
    // Without Unique Code Modal Submission
    const onSubmit = data => {
        console.log("onSubmit", uniqueCode);
        let dataObj = { "condition": { "practice_unique_name": uniqueCode, "user_type": "practice" } }
        dispatch(checkUniqueCodeAvailability(dataObj));
        setCheckingUniqueCode(true);
        setloading(true);
        setSnakbaropen(false);
        setSnackBarMsg("");
    }
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    if (snakbaropen) {
        setTimeout(() => {
            setSnakbaropen(false);
        }, 2000)
    }


    const Share4RewardsForm = {
        id: 'Share4RewardsForm',
        formtype: "add",
        // api_url: process.env.REACT_APP_API_URL,
        // endPoint: "api3/add-update-partner",
        // endPointBodyWrapper: "data",
        // urlPathOnSuccessfulFormSubmission: "/calendar",
        msgOnFailedFormSubmission: "Something Went Wrong",
        formWrapperClass: "Share4rewardsformWrapperClass",// Can be undefined default will be formCls
        formInlineCLass: "userForm", // Can be undefined default will be formInline
        formButtonClass: "submitbtnsection",
        submitBtnName: "Submit",
        // submitBtnStartIcon: 'image_search_icon',
        // submitBtnEndIcon: 'search_icon',
        resetBtnName: "Reset",
        formAdditionalSubmissionData: {

        },
        fields: [
            //////////////////////////////////// Text Input ///////////////////////////////
            {
                id: 0,
                // heading: "Full Name",
                label: "Name",
                name: "reward_partner_name",
                className: 'formfild',
                type: "text",
                rules: { required: true },
                errorMessage: {
                    required: "This Field is Required",
                    custom: "Value is Invalid"
                },
            },
            {
                id: 1,
                // heading: "Full Name",
                label: "Business Type",
                name: "business_type",
                className: 'formfild',
                type: "text",
                rules: { required: true },
                errorMessage: {
                    required: "This Field is Required",
                    custom: "Value is Invalid"
                },
            },
            {
                id: 2,
                // heading: "Full Name",
                label: "Email",
                name: "email",
                className: 'formfild',
                type: "text",
                inputType: "email",
                rules: { required: true },
                errorMessage: {
                    required: "This Field is Required",
                    custom: "Value is Invalid"
                },

            },
            {
                id: 3,
                // heading: "Full Name",
                label: "Phone No",
                name: "phone",
                className: 'formfild',
                type: "text",
                inputType: "phone",
                rules: { required: true, maxLength: 14 },
                errorMessage: {
                    required: "This Field is Required",
                    custom: "Value is Invalid",
                    maxLength: "Maximum Phone Number is 10"
                },

            },
            // {
            //     id: 4,
            //     // heading: "Full Name",
            //     label: "Location",
            //     name: "link_location",
            //     className: 'formfild',
            //     type: "select",
            //     // other: true,
            //     values: practicelocationArry,
            //     rules: { required: true },
            //     errorMessage: {
            //         required: "This Field is Required",
            //         custom: "Value is Invalid"
            //     },

            // },
            {
                id: 4,
                // heading: "Full Name",
                label: "Address",
                name: "address",
                className: 'formfild',
                type: "text",
                inputType: "text",
                rules: { required: true },
                errorMessage: {
                    required: "This Field is Required",
                    custom: "Value is Invalid"
                },

            },
            {
                id: 5,
                // heading: "Full Name",
                label: "City",
                name: "city",
                className: 'formfild',
                type: "text",
                rules: { required: true },
                errorMessage: {
                    required: "This Field is Required",
                    custom: "Value is Invalid"
                },

            },
            {
                id: 6,
                // heading: "Full Name",
                label: "State",
                name: "state",
                className: 'formfild state',
                type: "select",
                // other: true,
                values: locationArry,
                rules: { required: true },
                errorMessage: {
                    required: "This Field is Required",
                    custom: "Value is Invalid"
                },
                defaultValue: "",
            },
            {
                id: 7,
                // heading: "Full Name",
                label: "Zip",
                name: "zip",
                className: 'formfild',
                type: "text",
                inputType: "text",
                rules: { required: true, maxLength: 5, minLength: 5 },
                errorMessage: {
                    required: "This Field is Required",
                    custom: "Value is Invalid",
                    maxLength: "Maxlength length 5 allowed",
                    minLength: "Minlength length 5 allowed",
                },

            },
            {
                id: 8,
                // heading: "Full Name",
                label: "Unique Name",
                name: "uniqueid",
                className: 'formfild',
                type: "text",
                inputType: "text",
                rules: { required: true },
                errorMessage: {
                    required: "This Field is Required"
                },

            },


        ]

    };




    console.log("uniqueDetails ", isNoParam)

    return (
        <>

            <div className='share4rewards_banner'>
                <div className='share4rewards-container'>
                    {bannerLoading ? <LinearProgress /> : null}

                    {/* <div className='banner_demo_image'>
                        <div className="contact">
                            <p>{uniqueDetails?.phone && uniqueDetails.phone}</p>
                        </div>
                        <img src='https://all-frontend-assets.s3.amazonaws.com/share4rewards/demoimage1.png' />
                    </div> */}
                    {isNoParam ? uniqueDetails?.for_reward_partner_contact_no && uniqueDetails.for_reward_partner_contact_no != '' ?
                        <div className="banner_contact" >
                            <p><span><CallIcon /></span><a href={`tel:${uniqueDetails.for_reward_partner_contact_no}`}>{uniqueDetails.for_reward_partner_contact_no}</a></p>
                        </div>
                        :
                        uniqueDetails?.phone && uniqueDetails.phone ?
                            <div className="banner_contact" >
                                <p><span><CallIcon /></span><a href={`tel:${uniqueDetails.phone}`}>{uniqueDetails.phone}</a></p>
                            </div>
                            : ''
                        :
                        <div className="banner_contact" >
                            <p><span><CallIcon /></span><a href={`tel:(623)257-5471`}>(623)257-5471</a></p>
                        </div>
                    }

                    {isNoParam ?
                        uniqueDetails && uniqueDetails.reward_banner_details && uniqueDetails.reward_banner_details.header_banner ?
                            <div dangerouslySetInnerHTML={{ __html: uniqueDetails.reward_banner_details.header_banner }}></div>
                            : ""
                        :
                        <>
                            <div class="share4rewards_banner_Block">
                                <div class="share4rewards_banner_Block_logo"><img src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/share4rewards_banner_Block_demoLogo.webp" alt='' /></div>

                                <div class="share4rewards_banner_Block_text">
                                    <h2>Share 4 Rewards program offered by True Health Family Medicine</h2>
                                </div>
                                <img class="share4rewardsbannerBlockImg" src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/share4rewards_banner_Block_demoImg.webp" alt='' /></div>
                        </>
                    }

                    {/* <div className='share4rewards_banner_Block'>
                            <div className='share4rewards_banner_Block_logo'>
                               
                                {bannerLoading ? <LinearProgress /> : null}
                            </div>
                            <div className='share4rewards_banner_Block_text'>
                               
                                <h2>{bannerLoading ? <LinearProgress /> : null}</h2>
                            </div>
                          
                            {bannerLoading ? <LinearProgress /> : null}
                        </div> */}





                    <div className='landing-col-container'>
                        <div className='landing-banner-left'>

                            <div className='lpage_banner_titlewrapper'>

                                <h1>EARN HUNDREDS OF DOLLARS </h1>

                                <h1>FOR YOU AND YOUR EMPLOYEES </h1>

                                <h1>BY SHARING OUR <span>HEALTH RISK EXAM</span></h1>

                                <h1>OPPORTUNITY WITH YOUR CUSTOMERS </h1>


                            </div>
                            <div className='lpage_banner_sub_titlewrapper'>
                                <h2>Our no cost reward program will give you an opportunity to share with your customers the ability to catch potentially life-threatening diseases early.</h2>
                                {/* <h3>
                                    You have an opportunity to share with your customers the ability to catch potentially life-threatening diseases early.

                                </h3> */}
                            </div>
                            <div className='lpage_banner_titlewrapper'>
                                {/* <h2>You have an opportunity to share with </h2>
                                <h2>your clients and customers the ability</h2>
                                <h2>to catch potentially life threatening </h2>
                                <h2>diseases early. <span> Help us save lives! </span></h2> */}




                                <h2>There is no cost to our program, </h2>
                                <h2>and we provide you with the </h2>
                                <h2>simple materials you need to  </h2>
                                <h2><span>get started right away!</span></h2>
                            </div>
                            <div className='lpage_arrow_wrapper'>
                                <h2>Join us now and start helping your customers!</h2>
                            </div>


                        </div>
                        <div className='landing-banner-right landingOne'>
                            <div className='formwrapper' id="sectionForm">
                                <div className='formsubwrapper'>
                                    <div className='form_title_wrapper'>
                                        <h2>
                                            <span>Fill out this form </span>
                                            <span>so we can start your </span>
                                            <span>enrollment today!</span>
                                        </h2>
                                    </div>
                                    <div className='form_style'>
                                        <Form formData={Share4RewardsForm} /><br />
                                        {loading ? <LinearProgress /> : null}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div>
                <div className='mainbg'>

                    <RewardSecOne />
                    {isNoParam ? uniqueDetails && uniqueDetails.reward_banner_details && uniqueDetails.reward_banner_details.is_quarter_banner &&
                        <RewardSecThree mediaBanner={uniqueDetails && uniqueDetails.reward_banner_details && uniqueDetails.reward_banner_details.is_quarter_banner ? uniqueDetails.reward_banner_details.quarter_banner : null} /> :
                        <>
                            <div class="sb_block3_mainwrap">
                                <div class="share4rewards-container">
                                    <div class="share4rewards_content_wrapper">
                                        <h1>Example of our shared media</h1>
                                        <div class="sbcard_content_wrap">
                                            <div class="sbcard_content">
                                                <img alt="" src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/block3_leftimg_truehealth.jpg" />
                                            </div>
                                            <div class="sbcard_content">
                                                <img alt="" src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/block3_rightimg_truehealth.jpg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    <RewardSecFive />

                    {isNoParam ?
                        <RewardSecSix practiceData={uniquePracticeDetails} footerBanner={uniqueDetails && uniqueDetails.reward_banner_details && uniqueDetails.reward_banner_details.footer_banner} /> :
                        <>
                            <RewardSecSix />
                            <div class="share4rewards-container"><div class="footerbannerBlock">
                                <div class="footerbannerBlock_wrapper">
                                    <div class="footerbannerBlock_wrapper_logo">&nbsp;&nbsp;
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/share4rewards_banner_Block_demoLogo2.webp" alt='' />
                                    </div>
                                    <div class="footerbannerBlock_wrapper_text">
                                        <h2>Share 4 Rewards program offered by True Health Family Medicine</h2>
                                    </div>
                                    <img class="footerbannerBlockIMG" src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/share4rewards_banner_Block_demoImg2.webp" alt='' /></div>
                            </div>
                            </div>
                        </>
                    }
                    <RewardFooter />
                </div>


            </div>
            <div className="top-to-btm">
                {" "}
                {showTopBtn && (
                    <a className="icon-position icon-style" onClick={goToTop} ><KeyboardDoubleArrowUpIcon /></a>
                )}{" "}
            </div>
            <Snackbar
                className='loginSnack Snackbar_center'
                autoHideDuration={3000}
                open={snakbaropen}
                message={snackBarMsg}
                key="bottomcenter"

            />
            {/* <Modal
                open={isNoParam}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="withoutParamModal"
            >
                <Box sx={style}>
                    <div id="modal-modal-description" className='newsletter' sx={{ mt: 2 }}>
                        <div className="contentDiv_body">
                            <div class="headerText">Alert!</div>
                            <p>The link entered is incomplete. Please re-verify and enter the proper "Unique ID" of the practice or call the practice for the "Unique ID" and enter it here.</p>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <TextField
                                    margin="normal"
                                    className='uniquecode_input'
                                    id="uniquecode_input"
                                    name="uniquecode_input"
                                    placeholder='Type Unique Name Here'
                                    type="text"
                                    {...register("uniquecode_input", { required: true })}
                                    onChange={(e) => {
                                        setUniqueCode(e.target.value);
                                    }} />
                                {loading ? <LinearProgress /> : null}
                                {errorInUniqueCode ? <span className='errorMessage'>Unique Code not match!</span> : ""}
                                <div className='submitbtnsection'>
                                    <button type='submit'>SUBMIT</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Box>

            </Modal> */}


        </>
    )
}

export default Share4rewards
